import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingluxurycabrentalsindelhi() {



  const cardData =
  {
    keyword: 'Wedding Luxury Cab Rentals in Delhi',
    heading: 'Aaryan Travels: Wedding Luxury Cab Rentals in Delhi',
    headingDescription: 'Aaryan Travels offers premium Wedding Luxury Cab Rentals in Delhi to make your special occasions grand, elegant, and well-coordinated. Whether you need a luxury sedan for the groom’s entry, a premium SUV for family transport, or a convoy of high-end cars for VIP guests, our fleet—including Mercedes, BMW, Audi, and Innova Crysta—ensures style and sophistication. We also offer decorated bridal and baraat cars with uniformed chauffeurs for a royal experience. From South Delhi to Gurgaon, Noida to Aerocity, Aaryan Travels provides punctual and professional luxury cab arrangements for weddings, receptions, and engagement events across Delhi NCR.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Red Fort, built in 1648 by Mughal Emperor Shah Jahan, is a UNESCO World Heritage Site and one of India’s grandest historical monuments. Its red sandstone walls, majestic Lahori Gate, and sprawling courtyards reflect Mughal architectural brilliance. Every year on Independence Day, the Prime Minister hoists the national flag here. The evening light and sound show brings the fort’s glorious past to life. Red Fort is Delhi’s enduring symbol of power and freedom."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a 42-meter-high war memorial built in honor of Indian soldiers who sacrificed their lives during World War I. Surrounded by lush lawns and fountains, it is a popular spot for evening strolls and family outings. The Amar Jawan Jyoti flame burns eternally as a tribute to fallen heroes. At night, the monument glows beautifully under golden lights. India Gate is Delhi’s proud salute to courage and patriotism."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar, standing at 73 meters tall, is the world’s tallest brick minaret and a UNESCO World Heritage Site. Built in 1193 by Qutb-ud-din Aibak, it features intricate carvings and Quranic inscriptions across its five storeys. The nearby Iron Pillar, which has remained rust-free for centuries, fascinates scientists and historians. The complex is surrounded by ancient ruins and lush gardens. Qutub Minar is Delhi’s towering marvel of medieval engineering."
  },
  {
    "title": "Lotus Temple",
    "description": "Lotus Temple, shaped like a blooming lotus flower with 27 white marble petals, is a Bahá’í House of Worship open to people of all faiths. Unlike traditional temples, it has no idols and promotes silence and meditation. The surrounding ponds and gardens enhance its tranquillity. Visitors from around the world come here for peace and reflection. Lotus Temple is Delhi’s modern symbol of unity and spirituality."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb, built in 1570 by Empress Bega Begum, is the first garden-tomb in India and inspired the design of the Taj Mahal. The red sandstone monument is set amidst symmetrical Persian-style lawns with water channels. Birds and greenery add to the serene atmosphere. It is one of the finest examples of Mughal architecture. Humayun’s Tomb is Delhi’s regal tribute to eternal love and legacy."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a grand cultural and spiritual complex showcasing India’s ancient traditions through intricate stone carvings, boat rides, exhibitions, and musical fountain shows. Built without steel, it features over 20,000 sculpted deities and motifs. The evening water show, depicting the cycle of life, is a crowd favorite. Akshardham is Delhi’s majestic blend of devotion, art, and technology."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid, constructed by Shah Jahan in 1656, is one of the largest mosques in India. Its vast courtyard can accommodate over 25,000 worshippers. The red sandstone and white marble structure features three domes and two towering minarets. Visitors can climb the minaret for breathtaking views of Old Delhi. Jama Masjid is Delhi’s grand spiritual landmark."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a serene memorial dedicated to Mahatma Gandhi at the site of his cremation. A simple black marble platform marks the spot, inscribed with his last words, 'Hey Ram'. The surrounding gardens and eternal flame create an atmosphere of peace and respect. World leaders often visit to pay homage. Raj Ghat is Delhi’s humble tribute to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village blends historic ruins with modern cafes, boutiques, and art galleries. The 14th-century Hauz Khas Fort overlooks a beautiful lake where visitors relax and take photographs. By evening, the area comes alive with music, nightlife, and artistic gatherings. Hauz Khas is Delhi’s vibrant fusion of heritage and urban lifestyle."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest and busiest markets known for jewelry, spices, and textiles. Its narrow lanes lead to Paranthe Wali Gali, famous for serving hot stuffed parathas with chutneys and pickles. Cycle rickshaw rides offer a glimpse into old Delhi’s charm. The aroma, chaos, and flavors make it unforgettable. Chandni Chowk is Delhi’s bustling street of culture and cuisine."
  }
],



"services": [
  {
    "name": "Wedding Luxury Cab Rentals in Delhi",
    "description": "Wedding Luxury Cab Rentals in Delhi provide an exquisite fleet of high-end vehicles specifically tailored for wedding occasions. This service ensures elegance and sophistication for the bride, groom, and guests with luxury sedans, SUVs, and vintage cars, all maintained to pristine standards. Chauffeurs are professionally trained to handle wedding day logistics, ensuring punctuality, grace, and a memorable experience throughout the event."
  },
  {
    "name": "Bridal Car Rentals Delhi",
    "description": "Bridal Car Rentals Delhi specializes in offering stunning cars for the bride's arrival and departure. These vehicles come adorned with decorative elements, combining style and comfort to make the bride's journey special and hassle-free. The service includes experienced drivers who understand the significance of the occasion and provide discreet, timely transport."
  },
  {
    "name": "Luxury Wedding Taxi Delhi",
    "description": "Luxury Wedding Taxi Delhi offers premium taxis equipped with lavish interiors and advanced features for wedding guests and close family members. The service focuses on comfort, style, and reliability, ensuring that every ride complements the grandeur of the wedding festivities."
  },
  {
    "name": "Chauffeur Driven Wedding Cab Delhi",
    "description": "Chauffeur Driven Wedding Cab Delhi provides expert chauffeurs trained to cater to the nuances of wedding transportation. With a fleet of luxury vehicles, the chauffeurs manage routes, timing, and guest comfort, allowing the wedding party to focus entirely on their special day."
  },
  {
    "name": "Classic Wedding Car Delhi",
    "description": "Classic Wedding Car Delhi offers vintage and timeless vehicles that add a touch of tradition and charm to weddings. These classic cars are perfect for couples looking to blend elegance with heritage, providing a unique and photogenic transport option for the ceremony."
  },
  {
    "name": "Premium Wedding Cab Delhi",
    "description": "Premium Wedding Cab Delhi delivers luxury vehicles with impeccable service quality for all wedding-related travel. From guest pickups to venue transfers, this service guarantees punctuality, professionalism, and a plush travel experience that enhances the celebration."
  },
  {
    "name": "Luxury Wedding Sedan Delhi",
    "description": "Luxury Wedding Sedan Delhi provides high-end sedans known for their sleek design and comfort, ideal for the bride, groom, and close family members. The service ensures a smooth, stylish ride complemented by courteous chauffeurs dedicated to wedding day perfection."
  },
  {
    "name": "SUV for Wedding Delhi",
    "description": "SUV for Wedding Delhi offers spacious and elegant SUVs that accommodate larger groups or family members comfortably. These vehicles combine luxury with practicality, ensuring ample space for guests and luggage without compromising on style."
  },
  {
    "name": "Affordable Wedding Cab Delhi",
    "description": "Affordable Wedding Cab Delhi provides budget-friendly luxury cab options for weddings without sacrificing quality or comfort. Perfect for families and event planners looking for cost-effective yet elegant transportation solutions for wedding guests."
  },
  {
    "name": "Online Wedding Car Booking Delhi",
    "description": "Online Wedding Car Booking Delhi simplifies the process of reserving luxury wedding vehicles through a seamless digital platform. Customers can browse vehicle options, schedule pickups, and confirm bookings instantly, ensuring stress-free planning and reliable service on the big day."
  },
  {
    "name": "Delhi Wedding Chauffeur Services",
    "description": "Delhi Wedding Chauffeur Services offer highly trained drivers skilled in managing the unique demands of wedding day transportation. Chauffeurs ensure timely arrivals, courteous service, and professional handling of vehicles, enhancing the overall wedding experience."
  },
  {
    "name": "Wedding Event Cab Delhi",
    "description": "Wedding Event Cab Delhi specializes in handling large-scale wedding transportation needs, including guest shuttles, venue transfers, and coordinated travel schedules. The service is known for reliability, flexibility, and premium vehicle options to match the event’s grandeur."
  },
  {
    "name": "Executive Wedding Car Delhi",
    "description": "Executive Wedding Car Delhi provides luxury cars with executive features and amenities to cater to VIP guests and family members. This service focuses on delivering a sophisticated, comfortable, and exclusive travel experience tailored to the wedding context."
  },
  {
    "name": "Hire Wedding Cab Delhi",
    "description": "Hire Wedding Cab Delhi offers flexible rental packages for wedding cabs, including hourly, daily, and event-based hires. Customers can select from a range of luxury vehicles with chauffeur services, ensuring convenience and style throughout the wedding itinerary."
  },
  {
    "name": "Best Wedding Transport Delhi",
    "description": "Best Wedding Transport Delhi is recognized for delivering outstanding service, punctuality, and a premium fleet tailored for weddings. With a focus on client satisfaction and seamless logistics, this service is ideal for couples and planners who want flawless transportation for their special day."
  }
],
"tableData": [
  ["Wedding Luxury Cab Rentals in Delhi", "Bridal Car Rentals Delhi"],
  ["Luxury Wedding Taxi Delhi", "Chauffeur Driven Wedding Cab Delhi"],
  ["Classic Wedding Car Delhi", "Premium Wedding Cab Delhi"],
  ["Luxury Wedding Sedan Delhi", "SUV for Wedding Delhi"],
  ["Affordable Wedding Cab Delhi", "Online Wedding Car Booking Delhi"],
  ["Delhi Wedding Chauffeur Services", "Wedding Event Cab Delhi"],
  ["Executive Wedding Car Delhi", "Hire Wedding Cab Delhi"],
  ["Best Wedding Transport Delhi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Wedding Luxury Cab Rentals in Delhi",
    "WhyChoosedescription": "Aaryan Travels offers elegant wedding luxury cab rentals in Delhi, perfect for making your special day stylish and comfortable."
  },
  {
    "WhyChooseheading": "Premium Fleet of Luxury Cars",
    "WhyChoosedescription": "Choose from our selection of high-end vehicles, ideal for weddings, receptions, and related events."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers provide punctual, respectful, and seamless service tailored for wedding occasions."
  },
  {
    "WhyChooseheading": "Vehicle Decoration Services Available",
    "WhyChoosedescription": "Add a personalized touch with our wedding cab decoration options to complement your celebration."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for worry-free budgeting."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and any last-minute changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Select hourly, daily, or customized plans to perfectly suit your wedding schedule and transportation needs."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service on Your Wedding Day",
    "WhyChoosedescription": "We ensure prompt pickups and drop-offs so your wedding events proceed smoothly without transportation hassles."
  }
]













  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer wedding luxury cab rentals in Delhi?',
    answer: 'Yes, Aaryan Travels provides elegant wedding luxury cab rentals in Delhi to make your special day memorable and stylish.',
  },
  {
    question: 'How can I book wedding luxury cab rentals in Delhi with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Delhi.',
  },
  {
    question: 'What types of luxury vehicles are available for wedding rentals in Delhi?',
    answer: 'Aaryan Travels offers a selection of premium luxury cars including Mercedes, BMW, and Audi perfect for weddings in Delhi.',
  },
  {
    question: 'Are drivers trained and experienced for wedding luxury cab rentals in Delhi?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and respectful to ensure a smooth and grand wedding experience.',
  },
  {
    question: 'Can wedding luxury cab rentals in Delhi be customized for different wedding events?',
    answer: 'Yes, you can book luxury cabs for all wedding-related events such as the ceremony, reception, and guest transportation in Delhi.',
  },
  {
    question: 'Is the wedding luxury cab rental service available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels offers round-the-clock wedding luxury cab rental services in Delhi to suit your wedding schedule.',
  },
  {
    question: 'Are hygiene and safety protocols followed for wedding luxury cab rentals?',
    answer: 'All vehicles are thoroughly sanitized, and drivers adhere to strict safety and hygiene standards for your peace of mind.',
  },
  {
    question: 'What payment options are accepted for wedding luxury cab rentals in Delhi?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts for wedding luxury cab rentals.',
  },
  {
    question: 'Is customer support available during the wedding luxury cab rental period in Delhi?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your wedding luxury cab rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Singh',
    feedback: 'Aaryan Travels provided exceptional luxury cabs for our wedding in Delhi. The service was flawless and truly memorable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Verma',
    feedback: 'Highly recommend Aaryan Travels for wedding luxury cab rentals in Delhi. Professional drivers and immaculate cars made our day special.',
    rating: 5,
  },
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const weddingLuxuryCabDelhiSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Wedding Luxury Cab Rentals in Delhi",
  "description": "Aaryan Travels offers premium wedding luxury cab rentals in Delhi, including chauffeur-driven sedans and SUVs perfect for bridal car services and wedding events.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Delhi"
  },
  "serviceType": "Wedding Luxury Cab Rental Service",
  "keywords": "Wedding Luxury Cab Rentals in Delhi, Bridal Car Rentals Delhi, Luxury Wedding Taxi Delhi, Chauffeur Driven Wedding Cab Delhi, Classic Wedding Car Delhi, Premium Wedding Cab Delhi, Luxury Wedding Sedan Delhi, SUV for Wedding Delhi, Affordable Wedding Cab Delhi, Online Wedding Car Booking Delhi, Delhi Wedding Chauffeur Services, Wedding Event Cab Delhi, Executive Wedding Car Delhi, Hire Wedding Cab Delhi, Best Wedding Transport Delhi"
};




  return (
    <div>

<Helmet>
  <title>Wedding Luxury Cab Rentals in Delhi | Bridal & Executive Cars | Aaryan Travels</title>
  <meta
    name="description"
    content="Book wedding luxury cab rentals in Delhi with Aaryan Travels. Chauffeur-driven luxury sedans and SUVs for bridal services, wedding events, and executive transport."
  />
  <meta
    name="keywords"
    content="Wedding Luxury Cab Rentals in Delhi, Bridal Car Rentals Delhi, Luxury Wedding Taxi Delhi, Chauffeur Driven Wedding Cab Delhi, Classic Wedding Car Delhi, Premium Wedding Cab Delhi, Luxury Wedding Sedan Delhi, SUV for Wedding Delhi, Affordable Wedding Cab Delhi, Online Wedding Car Booking Delhi, Delhi Wedding Chauffeur Services, Wedding Event Cab Delhi, Executive Wedding Car Delhi, Hire Wedding Cab Delhi, Best Wedding Transport Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(weddingLuxuryCabDelhiSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingluxurycabrentalsindelhi;